<div class="approval-timeline-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon class="header-icon">timeline</mat-icon>
      Approval Timeline
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <app-approval-timeline [approvalData]="approvalData"></app-approval-timeline>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button class="btn btn-secondary" (click)="onClose()">Close</button>
  </div>
</div> 